var _path, _path2, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgConnectedInvestors = function SvgConnectedInvestors(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2999 14.2L18.3999 16.3L16.2999 18.4",
    stroke: "currentColor",
    strokeWidth: 1.368,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27995 4.95998C3.72551 4.95998 4.15281 4.78298 4.46787 4.46791C4.78293 4.15285 4.95992 3.72554 4.95992 3.27998C4.95992 2.83441 4.78293 2.4071 4.46787 2.09204C4.15281 1.77698 3.72551 1.59998 3.27995 1.59998C2.83439 1.59998 2.40708 1.77698 2.09203 2.09204C1.77697 2.4071 1.59998 2.83441 1.59998 3.27998C1.59998 3.72554 1.77697 4.15285 2.09203 4.46791C2.40708 4.78298 2.83439 4.95998 3.27995 4.95998Z",
    stroke: "currentColor",
    strokeWidth: 1.368,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95959 3.28015H8.31954C8.7651 3.28015 9.19241 3.45715 9.50746 3.77221C9.82252 4.08727 9.99952 4.51459 9.99952 4.96015V14.6202C9.99952 15.0657 10.1765 15.493 10.4916 15.8081C10.8066 16.1232 11.2339 16.3002 11.6795 16.3002H18.3994",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConnectedInvestors, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "assets/images/connectedInvestors.svg";
export { ForwardRef as ReactComponent };